import {push as pushHistory} from 'react-router-redux';
import {isObject} from '../utilities/common';
import {addFlashMessage} from './flash-messages';

export const formatErrors = (response = {}, redirectTo, doRedirect = true) => {
    if (response === null) {  // For request cancellation
        return () => Promise.resolve({});
    }

    if (response instanceof Error) {
        throw response;
    }
    const
        errorData = response.data || {},
        {errors = {}} = errorData,
        statusCode = response.status;
    const formFieldErrors = formatFieldErrors(errors);
    return dispatch => new Promise(resolve => {
        if (errorData.message) {
            dispatch(addFlashMessage(errorData.message, 'error', statusCode));
        }
        if (doRedirect) {
            redirect(dispatch, statusCode, redirectTo);
        }
        return resolve(formFieldErrors);
    });
};

export const formatFieldErrors = errors =>
    Object.entries(errors).reduce((errObj, [k, v]) => {
        return {
            ...errObj,
            [k]: isObject(v[0]) ? v.map(k => formatFieldErrors(k)) : v.join('; ')
        };
    }, {});

export const redirect = (dispatch, statusCode, redirectTo) => {
    let action;
    switch (statusCode) {
    case 401:
        action = pushHistory('/login');
        break;
    case 404:
        if (typeof redirectTo === 'string') {
            action = pushHistory(redirectTo);
        } else {
            action = pushHistory('/errors/404');
        }
        break;
    default:
        action = null;
    }
    if (action !== null) {
        dispatch(action);
    }
};



// WEBPACK FOOTER //
// ./src/js/actions/errors.js